import CreateAdtInfoTitleDialog from "./createAdtInfoTitleDialog.container";

export default CreateAdtInfoTitleDialog;
